<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <v-layout row>
      <!--PREVISION BUDGETAIRE-->
      <v-flex xs12>
        <v-layout row>
          <v-card style="width:100%">
            <v-card-text fluid grid-list-md>
              <h3>Prévision du budget</h3>
              <v-divider class="mb-2"></v-divider>

              <v-layout row>
                <v-flex class="mb-2">
                  <el-select
                    @change="filtrerMission"
                    v-model="selectEtatMiss"
                    placeholder="Filtrer la liste"
                  >
                    <el-option
                      v-for="item in comboEtatMiss"
                      :key="item.etat"
                      :label="item.label"
                      :value="item.etat"
                    >
                    </el-option>
                  </el-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs4>
                  <v-chip style="font-size:15px" label outline color="primary"
                    ><b
                      >TOTAL TRAVAUX EN ATTENTE DE VALIDATION :
                      {{
                        new Intl.NumberFormat().format(totalTravauxEnAttente)
                      }}
                    </b></v-chip
                  >
                </v-flex>
                <v-flex xs4>
                  <v-chip style="font-size:15px" label outline color="primary"
                    ><b
                      >TOTAL MONTANT PROPOSE :
                      {{ new Intl.NumberFormat().format(totalMntPropose) }}
                    </b></v-chip
                  >
                </v-flex>

                <v-flex xs4>
                  <v-chip style="font-size:15px" label outline color="primary"
                    ><b
                      >TOTAL MONTANT VALIDE :
                      {{ new Intl.NumberFormat().format(totalMntValide) }}
                    </b></v-chip
                  >
                </v-flex>

                <v-flex xs12 class="text-xs-right">
                  <v-tooltip top>
                    <v-btn
                      v-if="true"
                      slot="activator"
                      color="orange"
                      :disabled="false"
                      @click.stop="imprimeComptePDF()"
                      dark
                    >
                      Imprimer
                      <v-icon right>print</v-icon> </v-btn
                    >Imprimer le compte d'exploitation
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <el-tab-pane> </el-tab-pane>
              <v-layout row class="mb-4 mt-2">
                <v-flex xs12>
                  <data-tables :data="tableListeTrxBudget">

                    <el-table-column type="expand">
                      <template slot-scope="props">
                        <v-layout
                          wrap
                          class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4"
                        >
                          <v-flex xs12>
                            <span class="title">Liste des Tâches </span>
                            <v-divider class="mt-4"></v-divider>
                            <v-layout row>
                              <v-flex xs12 class="mr-2 mt-3">
                                <div class="grid-content">
                                  <v-flex xs12>
                                    <v-layout row wrap>
                                      <v-flex xs12>
                                        <el-table
                                          :data="props.row.taches"
                                          stripe
                                          style="width: 100%"
                                        >
                                          <el-table-column type="expand">
                                            <template slot-scope="props">
                                              <v-layout
                                                wrap
                                                class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4"
                                              >
                                                <v-flex xs12>
                                                  <span class="title"
                                                    >Détails budget</span
                                                  >
                                                  <v-divider class="mt-4">
                                                  </v-divider>
                                                  <v-layout row>
                                                    <v-flex
                                                      xs12
                                                      class="mr-2 mt-3"
                                                    >
                                                      <div class="grid-content">
                                                        <v-flex xs12>
                                                          <v-layout row wrap>
                                                            <v-flex xs12>
                                                              <el-table
                                                                :data="
                                                                  props.row
                                                                    .detailBudget
                                                                "
                                                                stripe
                                                                style="width: 100%"
                                                              >
                                                                <el-table-column
                                                                  align="center"
                                                                  prop="libelle"
                                                                  label="DESIGNATION"
                                                                >
                                                                </el-table-column>
                                                                <el-table-column
                                                                  align="center"
                                                                  prop="montantPropose"
                                                                  label="MONTANT PROPOSE"
                                                                >
                                                                  <template
                                                                    slot-scope="scope"
                                                                  >
                                                                    {{
                                                                      new Intl.NumberFormat().format(
                                                                        scope
                                                                          .row
                                                                          .montantPropose
                                                                      )
                                                                    }}
                                                                  </template>
                                                                </el-table-column>
                                                                <el-table-column
                                                                  align="center"
                                                                  prop="montantValide"
                                                                  label="MONTANT VALIDE"
                                                                >
                                                                  <template
                                                                    slot-scope="scope"
                                                                  >
                                                                    {{
                                                                      new Intl.NumberFormat().format(
                                                                        scope
                                                                          .row
                                                                          .montantValide
                                                                      )
                                                                    }}
                                                                  </template>
                                                                </el-table-column>
                                                                <el-table-column
                                                                  align="center"
                                                                  prop="periode"
                                                                  label="PERIODE"
                                                                >
                                                                </el-table-column>
                                                              </el-table>
                                                            </v-flex>
                                                          </v-layout>
                                                        </v-flex>
                                                      </div>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-flex>
                                              </v-layout>
                                            </template>

                                            <!-- details fin -->
                                          </el-table-column>

                                          <el-table-column
                                            prop="libelle"
                                            label="Libellé"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip outline text-color="blue" label> {{ scope.row.libelle }}</v-chip>
                                              <!-- <span v-for="(item, index) in scope.row.libelle" :key="index">
                                                <v-chip outline text-color="blue" label> {{ item }}</v-chip>/
                                              </span>  -->
                                            </template>                                             
                                          </el-table-column>
                                          <el-table-column
                                            prop="mntBudgetPropose"
                                            label="MONTANT PROPOSE"
                                            align="center"
                                            sortable
                                          >
                                            <template slot-scope="scope">
                                              <el-tag :type="'warning'">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    scope.row.mntBudgetPropose
                                                  )
                                                }}
                                              </el-tag>
                                            </template>
                                          </el-table-column>

                                          <el-table-column
                                            prop="mntBudgetValide"
                                            label="MONTANT VALIDE"
                                            align="center"
                                          >
                                            <template slot-scope="scope">
                                              <el-tag :type="'success'">
                                                {{
                                                  new Intl.NumberFormat().format(
                                                    scope.row.mntBudgetValide
                                                  )
                                                }}
                                              </el-tag>
                                            </template>
                                          </el-table-column>

                                          <el-table-column
                                            label="ACTION"
                                            prop="action"
                                            align="center"
                                          >
                                            <template slot-scope="scope"> 
                                              <v-tooltip top>
                                                  <v-btn v-if="scope.row.mntBudgetValide == 0" slot="activator" @click="modalAjoutBudget(scope.row,true)" flat dark small color="primary">
                                                      Modifier
                                                  </v-btn>
                                                  Modifier le budget
                                              </v-tooltip>  
                                            </template>
                                          </el-table-column>

                                        </el-table>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </template>
                    </el-table-column>

                    <el-table-column prop="libelle" label="TRAVAUX" sortable>
                      <template slot-scope="scope">
                        <span class="orange--text">{{
                          scope.row.libelle
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="MONTANT PROPOSE"
                      align="center"
                      prop="mntBudgetPropose"
                    >
                      <template slot-scope="scope">
                        <el-tag :type="'warning'">
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.mntBudgetPropose
                            )
                          }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column
                      label="MONTANT VALIDE"
                      align="center"
                      prop="mntBudgetValide"
                    >
                      <template slot-scope="scope">
                        <el-tag :type="'success'">
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.mntBudgetValide
                            )
                          }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column prop="etat" label="ETAT" align="center">
                      <template slot-scope="scope">
                        <el-tag
                          :type="scope.row.etat == 1 ? 'success' : 'warning'"
                          disable-transitions
                          >{{ scope.row.libEtat }}</el-tag
                        >
                      </template>
                    </el-table-column>

                    <el-table-column
                      label="ACTION"
                      prop="action"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <v-tooltip top>
                          <v-btn
                            v-if="scope.row.etat == 3"
                            slot="activator"
                            @click="modalAjoutBudget(scope.row)"
                            fab
                            dark
                            small
                            color="blue"
                          >
                            <v-icon dark>add</v-icon> </v-btn
                          >Etablir le budget
                        </v-tooltip>

                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <!--PREVISION BUDGETAIRE-->
    </v-layout>

    <!--&lt;!&ndash;IMPORT&ndash;&gt;-->
    <AjoutPrevisionBudgetChantier
      :show="showModalAjoutPrevision"
      :typeTrx="typeTravaux"
      :typeEtat = "typeEtat"
      :idChant="this.chantier.id"
      @close="
        showModalAjoutPrevision = false;
        loadListeTravaux();
      "
    ></AjoutPrevisionBudgetChantier>
  </div>
</template>

<script>
//function de difference de date

var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";
import Loading from "@/components/Loading";
import AjoutPrevisionBudgetChantier from "@/components/boardChantier/AjoutPrevisionBudgetChantier";

export default {
  components: {
    Loading,
    AjoutPrevisionBudgetChantier
  },
  props: {
    show: {
      type: Boolean
    },
    chantier: {
      type: Object
    }
  },
  name: "CompteExploitationChantier",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,

      //VARIABLE
      tableListeTrxBudget: [],
      selectEtatMiss: "",
      tableOldListeTrxBudget: [],
      comboEtatMiss: [
        {
          etat: 0,
          label: "Toutes les missions"
        },
        {
          etat: 1,
          label: "Avec budget"
        },
        {
          etat: 2,
          label: "Sans budget"
        }
      ],
      totalMntPropose: 0,
      totalMntValide: 0,
      totalTravauxEnAttente: 0,

      //MODAL AJOUT PREVISION
      showModalAjoutPrevision: false,
      typeTravaux: [],
      typeEtat: false,
      dateAnMois: null,
      labelPosition: "top"
    };
  },
  computed: {},
  watch: {
    show: function(newValue, oldValue) {
      this.tableListeTrxBudget.splice(0);
      if (newValue == true) {
        this.loadListeTravaux();
      }
    }
  },
  methods: {
    filtrerMission(etat) {
      let old = this.tableOldListeTrxBudget;
      this.tableListeTrxBudget = old;
      if (etat === 1) {
        this.tableListeTrxBudget = this.tableListeTrxBudget.filter(function(
          item
        ) {
          if (item.detailBudget.length > 0) {
            return item;
          }
        });
      } else if (etat === 2) {
        this.tableListeTrxBudget = this.tableListeTrxBudget.filter(function(
          item
        ) {
          if (item.detailBudget.length == 0) {
            return item;
          }
        });
      } else {
        return (this.tableListeTrxBudget = old);
      }
    },
    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    format(percentage) {
      return `${percentage}%`;
    },

    getSumm(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },

    modalAjoutBudget(item, etat = null) {
      console.log('rjjrr dans chantier',item,etat)
      this.typeTravaux = item;
      this.typeEtat = etat;
      this.showModalAjoutPrevision = true;
    },

    loadListeTravaux() {
      this.loading = true;
      let url = this.domaine + "budgetChantier/chantier/" + this.chantier.id;
      this.$http.get(url).then(
        resp => {
          this.loading = false;
          this.tableListeTrxBudget = resp.body.listeTypeTrx;
          this.tableOldListeTrxBudget = resp.body.listeTypeTrx;
          this.totalMntPropose = resp.body.totalMntPropose;
          this.totalMntValide = resp.body.totalMntValide;
          this.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation"
          );
        }
      );
    },
    imprimeComptePDF() {
      let url =
        this.domaine +
        "budgetChantier/" +
        this.chantier.id +
        "/" +
        this.user.id +
        "/imprimer_compteExploi_pdf";
      window.open(url);
    },

    //recherche info projet ou chantier
    submitForm() {}
  },

  mounted() {}
};
</script>

<style>
tr td.el-table__expanded-cell {
  background-color: #eeeeee;
}

td.el-table__expanded-cell div {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/boardChantier/CompteExploitationChantier.vue